/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: MarkerSignalButton.tsx
 * Project: mle-client-n
 * Committed last: 2022/6/14 @ 1053
 * ---
 * Description:
 */

import { Button, Intent } from '@blueprintjs/core';

interface Props {
  text: string;
  className?: string;
  minimal?: boolean;
  intent?: Intent;
}

export const MarkerSignalButton = (props: Props) => {
  return (
    <Button
      onClick={ () => (window as any).Marker.capture('fullscreen') }
      minimal={ props.minimal !== undefined ? props.minimal : true }
      className={ props.className }
      intent={ props.intent || Intent.NONE }
    >{ props.text }</Button>
  );
};